export default {"src":"/_next/static/media/cross.69c8ecfd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};